// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","headerText":"Header_headerText__VErRs","headerLink":"Header_headerLink__36hV1","headerP":"Header_headerP__11jtc"};